import { gql } from "@apollo/client";

export const totalCustomerContractUser = gql`
    query total {
        userList {
            total
        }
        clientList {
            total
        }
    }
`;